<template>
  <router-view></router-view>
</template>

<script>
export default {
  mounted () {
    // Automatically navigate to Document Categories when the component is mounted
    this.redirectToChild()
  },
  watch: {
    // Watch for changes in the route
    $route (to, from) {
      // If the current route is the main document config page, redirect to categories
      if (to.path === '/management-details/media-config') {
        this.redirectToChild()
      }
    }
  },
  methods: {
    redirectToChild () {
      this.$router.push('/management-details/media-config/media-categories')
    }
  }
}
</script>
